import ProfileMenu, { ProfileMenuProps } from './ProfileMenu';

export type { ProfileMenuProps };
export default ProfileMenu;
